import { defaults, getAPIMethod } from 'typed/api';
import { ExtractAction, entityActionSet, networkAction } from './utils';

export const
    { loadAll: loadAllLightDashboardGroups } = entityActionSet(defaults.DashboardGroupLightReport, {
        loadAll: networkAction('LOAD_ALL_LIGHT_DASHBOARD_GROUPS', getAPIMethod('DashboardGroup', 'loadAllLight'))
    }),
    { loadAll: loadAllDashboardPageTemplates } = entityActionSet(defaults.DashboardPageTemplate, {
        loadAll: networkAction('LOAD_ALL_DASHBOARD_PAGE_TEMPLATES', getAPIMethod('DashboardPageTemplate', 'loadAll'))
    }),
    { loadAll: loadAllDashboardPageBlockTemplates } = entityActionSet(defaults.DashboardPageBlockTemplate, {
        loadAll: networkAction('LOAD_ALL_DASHBOARD_PAGE_BLOCK_TEMPLATES', getAPIMethod('DashboardPageBlockTemplate', 'loadAll'))
    }),
    { loadAll: loadAllDashboardBlockCustomTableGraphSerieTypes } = entityActionSet(defaults.DashboardPageBlockCustomTableGraphSerieType, {
        loadAll: networkAction('LOAD_ALL_DASHBOARD_BLOCK_CUSTOM_TABLE_GRAPH_SERIE_TYPE', getAPIMethod('DashboardPageBlockCustomTableGraphSerieType', 'loadAll'))
    }),
    { loadAll: loadAllDashboardBlockCustomTableColumnDefaultFilters } = entityActionSet(defaults.DashboardPageBlockCustomTableColumnDefaultFilter, {
        loadAll: networkAction('LOAD_ALL_DASHBOARD_BLOCK_CUSTOM_TABLE_COLUMN_DEFAULT_FILTERS', getAPIMethod('DashboardPageBlockCustomTableColumnDefaultFilter', 'loadAll'))
    });

export type DashboardsAction = ExtractAction<
| typeof loadAllLightDashboardGroups
| typeof loadAllDashboardPageTemplates
| typeof loadAllDashboardPageBlockTemplates
| typeof loadAllDashboardBlockCustomTableGraphSerieTypes
| typeof loadAllDashboardBlockCustomTableColumnDefaultFilters
>;
